import React, { useState } from "react";
import styles from "../../../views/ReportView/ReportView.module.css";
import IconAnimation from "../../iconAnimation/iconAnimation";
import NotReportViewData from "../../NotReportViewData/NotReportView";
import { BiMessageAltError } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";

const TerrorismInformationCompanyComponent = ({ data }) => {
  const [company, setCompany] = useState(data);
  const [isEditing] = useState(false);
  const navigate = useNavigate();

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setCompany({ ...company, [name]: value });
  };

  const handleTerrorist = (e, data) => {
    e.preventDefault();
    navigate("/lealtad/informe/terrorismo-pdf", { state: data });
  };

  return (
    <div className={styles.LealtadinformacionPolitica} id="terrorismo">
      <div className={styles.LealtadsectionTitle2}>
        <div className={styles.LealtadsectionTitle3}>
          <h2 className={styles.LealtadsectionTitleH2}>
            Información Terrorismo
          </h2>
          <IconAnimation />
        </div>
        <div className="abmlistviewbutton">
          <button
            type="button"
            id="idbuttonabmviewlist-lealtad"
            className="buttonviewñostabm-lealtad"
            onClick={(e) => handleTerrorist(e, data)}
          >
            <i className="fa fa-refresh"></i> Terrorismo
            <FaArrowRight className={styles.Lealtadicon} />
          </button>
        </div>
      </div>
      {!company || !company.PoliticalInformationCompany ? (
        <NotReportViewData
          title="Información Terrorismo"
          Icon={BiMessageAltError}
        />
      ) : (
        <>
          <label className={styles.LealtadinputLabel}>
            Resultado:
            <textarea
              className={styles.LealtadinputField}
              type="text"
              name="terrorismVerification2"
              value={company.PoliticalInformationCompany.verification || ""}
              onChange={handleInputChange}
              readOnly={!isEditing}
            />
          </label>
          <label className={styles.LealtadinputLabel}>
            Verificación de terrorismo (DNI):
            <input
              className={styles.LealtadinputField}
              type="text"
              name="terrorismVerification"
              value={
                company.PoliticalInformationCompany.terrorismVerification || ""
              }
              onChange={handleInputChange}
              readOnly={!isEditing}
            />
          </label>
        </>
      )}
    </div>
  );
};

export default TerrorismInformationCompanyComponent;
